<section (click)="viewState.showOptions = false" class="options-section">
  <h2 class="heading-underline">Docusign</h2>

  <div class="recipient-num">
    <h4>Recipient number</h4>
    <input [(ngModel)]="recipientNo" disabled="{{ !viewState.showFields || viewState.showChildFields }}" type="number" min="1" />
  </div>

  @if (viewState.showDataLabel && dataLabel) {
    <div class="data-label">
      <div>
        <div>Docusign Data Label:</div>
        <div>
          <b>{{ dataLabel }}</b>
        </div>
      </div>
      <button
        class="toolbar-button"
        theme="small"
        title="Copy"
        (click)="copyToClipboard()"
        (keydown.enter)="copyToClipboard()"
        (keydown.space)="copyToClipboard()"
        >
        <div
          class="tooltip"
        [ngClass]="{
          visible: tooltipState.visible,
          hidden: !tooltipState.visible
        }"
          >
          <span class="tooltiptext"><mat-icon fontIcon="check"></mat-icon>Copied</span>
        </div>
        <mat-icon fontIcon="content_copy"></mat-icon>
      </button>
    </div>
  }

  @if (viewState.showNoActions) {
    <p style="padding: 10px 10px 0 10px">There are no actions available at the current location.</p>
  }

  @if (viewState.hasOptions && !viewState.showOptions) {
    <button
      @buttonInOut
      (click)="showOptions($event)"
      class="insert-update-field"
      theme="medium"
      title="Configuration options for {{ activeField?.label }}"
      >
      {{ activeField?.label }} OPTIONS
    </button>
  }

  @if (viewState.showFields) {
    <span class="fieldsList">
      <mat-selection-list [multiple]="false" hideSingleSelectionIndicator>
        @for (field of docusignTabTypes; track field.type) {
          <mat-list-option
            [value]="field"
            (click)="fieldAdded(field)"
            (keydown.enter)="fieldAdded(field)"
            (keydown.space)="fieldAdded(field)"
            title="Click to add {{ field.label }} to the document"
            >
            <mat-icon fontIcon="chevron_left" class="add-to-document"></mat-icon>{{ field.label }}
          </mat-list-option>
        }
      </mat-selection-list>
    </span>
  }
</section>

@if (viewState.hasOptions && viewState.showOptions) {
  <app-docusign-options
    (fieldClickedEvent)="this.fieldClickedEvent.emit($event)"
    (closeOptionsEvent)="closeOptions()"
    >
  </app-docusign-options>
}
